import React, { useEffect, useState } from 'react';
import { getPublicParentFeedback } from '../api/parentFeedback';
import './PublicParentTestimonials.css';

function safeText(value) {
  return String(value || '').trim();
}

function normalizePublicFeedback(item, index) {
  return {
    id: item.id || item.feedbackId || `public-feedback-${index}`,
    displayName: safeText(item.displayName || item.parentDisplayName || item.parentName),
    headline: safeText(item.headline || item.title),
    feedbackText: safeText(item.feedbackText || item.comment || item.text),
    rating: Number(item.rating || 0),
    subject: safeText(item.subject),
    grade: safeText(item.grade || item.studentGrade)
  };
}

export default function PublicParentTestimonials({ limit = 3, compact = false }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    getPublicParentFeedback({ limit })
      .then((data) => {
        if (cancelled) return;
        setItems(data.map(normalizePublicFeedback).filter((item) => item.feedbackText));
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      });
    return () => {
      cancelled = true;
    };
  }, [limit]);

  if (items.length === 0) return null;

  return (
    <section className={compact ? 'publicTestimonials publicTestimonials--compact' : 'publicTestimonials'}>
      <div className="publicTestimonials__inner">
        <h2>What parents say</h2>
        <div className="publicTestimonials__grid">
          {items.map((item) => (
            <article className="publicTestimonials__card" key={item.id}>
              {item.rating > 0 && <div className="publicTestimonials__rating">{item.rating}/5</div>}
              {item.headline && <h3>{item.headline}</h3>}
              <p>"{item.feedbackText}"</p>
              <footer>
                <strong>{item.displayName || 'TutorOrca parent'}</strong>
                {[item.subject, item.grade].filter(Boolean).length > 0 && (
                  <span>{[item.subject, item.grade].filter(Boolean).join(' - ')}</span>
                )}
              </footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
